import { LockDataAction } from "./constants";
import { RunPayrollCheckLockData } from "./types";

export const checkLockedData = (data: RunPayrollCheckLockData[] = []) => {
  return !data.length
    ? false
    : data?.every((item) => item.action === LockDataAction.LOCK);
};
